/* Storefront consent evidence supplements Shopify's checkout subscription agreement. */
(function () {
  'use strict';
  var states = new WeakMap();
  function writeText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function sync(box) {
    var form = box.closest('form');
    if (!form) return null;
    var state = states.get(box);
    if (!state) {
      try { state = { data: JSON.parse(box.querySelector('[data-heil-subscription-data]').textContent), key: '' }; }
      catch (_) { return null; }
      states.set(box, state);
    }
    var planInput = form.querySelector('[name="selling_plan"]');
    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"][form="' + form.id + '"]');
    var plan = planInput && planInput.value;
    var variant = state.data.variants.find(function (v) { return String(v.id) === (variantInput && variantInput.value); });
    var allocation = variant && variant.allocations.find(function (a) { return String(a.id) === plan; });
    var active = !!plan;
    var quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
    var checkbox = box.querySelector('[data-heil-subscription-consent]');
    var key = active ? [plan, variantInput && variantInput.value, quantity, allocation && allocation.price].join('|') : '';
    if (state.key !== key) {
      checkbox.checked = false;
      state.key = key;
      box.querySelector('[data-heil-subscription-error]').hidden = true;
      state.time = '';
    }
    box.hidden = !active;
    checkbox.disabled = !active;
    checkbox.required = active;
    form.toggleAttribute('data-heil-subscription-active', active);
    var lang = box.dataset.locale;
    var prefix = lang === 'zh-CN' ? '定期商品费用：' : lang === 'zh-TW' ? '定期商品費用：' : lang === 'vi' ? 'Tiền sản phẩm định kỳ: ' : 'Recurring product charge: ';
    var summary = '';
    if (allocation) {
      var price = new Intl.NumberFormat(lang, { style: 'currency', currency: box.dataset.currency || 'USD' }).format(allocation.price * quantity / 100);
      summary = prefix + price + ' · ' + allocation.name + (quantity > 1 ? ' · ' + quantity + ' ×' : '');
    }
    writeText(box.querySelector('[data-heil-subscription-summary]'), summary);
    var accepted = active && allocation && checkbox.checked;
    if (accepted && !state.time) state.time = new Date().toISOString();
    if (!accepted) state.time = '';
    var values = {
      consent: 'Agreed',
      terms: summary + ' | ' + box.querySelectorAll('p')[1].textContent.trim() + ' | ' + box.querySelectorAll('p')[2].textContent.trim(),
      time: state.time,
      version: '2026-10-15'
    };
    box.querySelectorAll('[data-heil-consent-property]').forEach(function (input) {
      input.disabled = !accepted;
      input.value = values[input.dataset.heilConsentProperty];
    });
    if (accepted) box.querySelector('[data-heil-subscription-error]').hidden = true;
    return { active: active, accepted: accepted, checkbox: checkbox, box: box };
  }
  function refresh() { document.querySelectorAll('[data-heil-subscription]').forEach(sync); }
  function validate(event) {
    var form = event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var box = form.querySelector('[data-heil-subscription]');
    var state = box && sync(box);
    if (state && state.active && !state.accepted) {
      event.preventDefault();
      event.stopImmediatePropagation();
      box.querySelector('[data-heil-subscription-error]').hidden = false;
      state.checkbox.focus();
    }
  }
  document.addEventListener('submit', validate, true);
  document.addEventListener('change', function () { refresh(); setTimeout(refresh, 100); }, true);
  document.addEventListener('input', function (e) { if (e.target.name === 'quantity') refresh(); }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('product-quantity button')) setTimeout(refresh, 0);
  }, true);
  function init() {
    refresh();
    var scheduled = false;
    new MutationObserver(function (mutations) {
      if (scheduled || !mutations.some(function (m) { return !m.target.closest || !m.target.closest('[data-heil-subscription]'); })) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; refresh(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
